{
  "search": "بحث",
  "searchWithin": "بحث في"
}
